var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2c16.569 0 30 13.431 30 30 0 16.568-13.431 30-30 30C15.431 62 2 48.568 2 32 2 15.43 15.431 2 32 2z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.98 41.117H35.005c-1.737 0-3.158-1.437-3.158-3.193v-4.02c0-1.756 1.421-3.193 3.158-3.193H47.98v10.406zM40.227 21.142L37.723 16l-12.356 5.223",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.59 36.93h0c-.556 0-1.01-.459-1.01-1.02 0-.56.454-1.02 1.01-1.02.554 0 1.009.46 1.009 1.02 0 .561-.455 1.02-1.01 1.02z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.637 41.128V44.8c0 1.756-1.422 3.193-3.16 3.193H19.16C17.422 47.993 16 46.556 16 44.8V27.028c0-1.756 1.422-3.193 3.16-3.193h23.318c1.737 0 3.16 1.437 3.16 3.193v3.625",
    strokeWidth: 1.5
  })))));
};
export default SvgWallet;